// extracted by mini-css-extract-plugin
export default {"root":"Topics_root__wx7OA","filter":"Topics_filter__440zO","block":"Topics_block__Nwxu2"};